import { createSlice } from "@reduxjs/toolkit";

const currencySlice = createSlice({
name:"currency",
initialState:{
    currencies : [],
    loading:false,
    error:null
},
reducers: {
    fetchCurrenciesStart:(state)=>{
        state.loading = true;
        state.error = null
    },
    fetchCurrenciesSuccess:(state, action) =>{
        state.loading = false;
        state.currencies = action.payload
    },
    fetchCurrenciesFailure:(state, action)=>{
        state.loading = false;
        state.error = action.payload
    }
}
})

export const {fetchCurrenciesStart, fetchCurrenciesSuccess, fetchCurrenciesFailure} = currencySlice.actions;

export default currencySlice.reducer